export const IS_SERVER = typeof globalThis.window === 'undefined'
